export default "__VITE_ASSET__BfkBMzGJ__"